import { Box } from 'braid-design-system';
import type React from 'react';

interface DisabledInterface {
  disabled: boolean;
  children: React.ReactNode;
}

export const DisableLocations = ({ disabled, children }: DisabledInterface) => {
  if (disabled) {
    return (
      <Box style={{ opacity: 0.6, pointerEvents: 'none' }} disabled>
        {children}
      </Box>
    );
  }
  return <Box>{children}</Box>;
};
